import { render, staticRenderFns } from "./IpConsent.vue?vue&type=template&id=95ba206c&"
import script from "./IpConsent.vue?vue&type=script&lang=js&"
export * from "./IpConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports